module.exports = __webpack_public_path__ + "teqbahn-assets/media/impact3.852d447f.jpeg";